import React from "react";
var __jsx = React.createElement;
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { AtomicBlockType } from '@uno/common-cms';
import { Blocks } from 'components/common/RichTextEditor/types';
import { TableGrid } from 'components/common/TableGrid';
import { Table } from 'theme/icons';
import { AddButtonBlock, Container } from './BlockToolbar.style';

var BlockToolbar = function BlockToolbar(_ref) {
  var setEditorState = _ref.setEditorState,
      enabledBlocks = _ref.enabledBlocks,
      insertTable = _ref.insertTable;

  var _useState = useState(false),
      isTableGridOpen = _useState[0],
      setIsTableGridOpen = _useState[1];

  var intl = useIntl();
  var label = intl.formatMessage({
    id: 'content.labels.block-toolbar.table'
  });
  return __jsx(Container, {
    "data-testid": "block-toolbar"
  }, __jsx(AddButtonBlock, {
    onClick: function onClick(event) {
      event.stopPropagation();
      setIsTableGridOpen(function (prevValue) {
        return !prevValue;
      });
    },
    title: label,
    "aria-label": label
  }, __jsx(Table, null), isTableGridOpen && __jsx(TableGrid, {
    insertTable: insertTable
  })), enabledBlocks.map(function (block) {
    var _Blocks$block;

    var BlockToolbarComponent = (_Blocks$block = Blocks[block]) === null || _Blocks$block === void 0 ? void 0 : _Blocks$block.blockToolbarComponent;

    if (BlockToolbarComponent === undefined) {
      return;
    }

    if (block === AtomicBlockType.BEOP && process.env.STAGE === 'production') {
      return;
    }

    return __jsx(BlockToolbarComponent, {
      setEditorState: setEditorState,
      key: block
    });
  }));
};

export default BlockToolbar;